"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodCash = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Select_1 = require("../../Form/Field/Select");
const utils_1 = require("../../Form/Field/Select/utils");
const messages_1 = require("./messages");
const Select_2 = require("./Select");
const PaymentMethodCash = (props) => {
    const { select, value, setValue, items, hidden, modificators } = props;
    const intl = (0, react_intl_1.useIntl)();
    if (hidden)
        return null;
    return (react_1.default.createElement(Select_2.PaymentMethodSelect, { icon: 'dollars', title: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/Payment/Method:Cash', defaultMessage: 'Cash' })), select: select, field: react_1.default.createElement(Select_1.FormFieldSelect, { placeholder: intl.formatMessage(messages_1.messages.selectPlaceholder), value: value, setValue: setValue, items: items, toItem: utils_1.mapAccountListItemToSelectItem, modificators: 'no-border' }), modificators: modificators }));
};
exports.PaymentMethodCash = PaymentMethodCash;
//# sourceMappingURL=Cash.js.map